// extracted by mini-css-extract-plugin
export default {"tooltip":"mantineTooltip_tooltip__kzF2v"};